<template>
    <div>
        <form id="shareholder_form" class="bg-white p-4 rounded shadow-sm">
            <div class="row">
                <div class="col-12 col-md-6 my-2">
                    <label v-text="$t('label.first_name')"
                           for="first_name"
                    ></label>
                    <input id="first_name"
                           name="first_name"
                           class="form-control"
                           v-model="form_data.first_name"
                    >
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label v-text="$t('label.last_name')"
                           for="last_name"
                    ></label>
                    <input id="last_name"
                           name="last_name"
                           class="form-control"
                           v-model="form_data.last_name"
                    >
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label for="wallet_hashid">
                        <span v-text="$t('label.wallet_hashid')"></span>
                        <span v-text="$t('label.optional_input')" class="mx-1"></span>
                    </label>
                    <input id="wallet_hashid"
                           name="wallet_hashid"
                           class="form-control"
                           dir="ltr"
                           v-model="form_data.wallet_hashid"
                    >
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label>
                        <span v-text="$t('label.account_or_sheba')"></span>
                        <span v-text="$t('label.optional_input')" class="mx-1"></span>
                    </label>
                    <button type="button"
                            class="btn btn-primary pl-2 pr-0 py-1 my-0 mx-1"
                            @click="addAccountNumber"
                    >
                        <i class="fas fa-plus"></i>
                    </button>
                    <button type="button"
                            class="btn btn-danger pl-2 pr-0 py-1 my-0 mx-1"
                            @click="removeAccountNumber"
                            v-if="form_data.account_numbers.length > 1"
                    >
                        <i class="fas fa-minus"></i>
                    </button>
                    <div v-for="(account_number, index) in form_data.account_numbers"
                         :key="index"
                         class="mb-2"
                    >
                        <input :id="`account_numbers_${index}`"
                               :name="`account_numbers_${index}`"
                               class="form-control transfers_destination_number"
                               dir="ltr"
                               v-model="form_data.account_numbers[index]"
                        >
                    </div>
                </div>
            </div>
            <button type="button"
                    @click="submit"
                    v-text="submit_btn_text"
                    class="btn btn-success mt-4"
            ></button>
        </form>
    </div>
</template>

<script>
import Inputmask from 'inputmask';
    export default {
        props: {
            submit: {
                required: true,
                type: Function,
                default: () => {},
            },
            submit_btn_text: {
                required: true,
                type: String,
            },
            form_data: {
                required: true,
                type: Object,
            },
        },
        watch:{
            transfer_length() {
                setTimeout(() => {
                    this.initShebaMask();
                }, 500);
            },
        },
         computed: {
            transfer_length() {
                return this.form_data.account_numbers;
            },
        },
         mounted(){
            this.initShebaMask();
        },
        methods: {
            addAccountNumber() {
                this.form_data.account_numbers.push('');
            },
            removeAccountNumber() {
                this.form_data.account_numbers.pop();
            },
            initShebaMask() {
                Inputmask("IR 9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('.transfers_destination_number'));
            },
        },
    }
</script>
